/**
 * Approval Queue UI Component
 * Renders pending tool approvals with batch actions
 */

import { approvals } from '../tools/approvals.js';

export function renderApprovalQueue() {
  const pending = approvals.getPending();
  if (pending.length === 0) return '';

  const showBatch = pending.length > 1;

  return `
    <div class="approval-queue">
      ${showBatch ? `
        <div class="approval-batch-header">
          <span>${pending.length} pending approvals</span>
          <div class="approval-batch-actions">
            <button class="approval-btn approve" data-action="approve-all">Approve All</button>
            <button class="approval-btn deny" data-action="deny-all">Deny All</button>
          </div>
        </div>
      ` : ''}
      ${pending.map(item => renderApprovalCard(item)).join('')}
    </div>
  `;
}

function renderApprovalCard(item) {
  const riskClass = item.risk || 'medium';

  return `
    <div class="approval-card" data-approval-id="${item.id}">
      <div class="approval-card-header">
        <span class="approval-tool-name">${item.toolName}</span>
        <span class="approval-risk ${riskClass}">${riskClass}</span>
      </div>
      <div class="approval-params">
        ${JSON.stringify(item.params, null, 2)}
      </div>
      <div class="approval-actions">
        <button class="approval-btn approve" data-action="approve" data-id="${item.id}">Approve</button>
        <button class="approval-btn deny" data-action="deny" data-id="${item.id}">Deny</button>
      </div>
    </div>
  `;
}

export function bindApprovalEvents(container) {
  container.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;

    switch (btn.dataset.action) {
      case 'approve':
        await approvals.approve(btn.dataset.id);
        break;
      case 'deny':
        approvals.deny(btn.dataset.id);
        break;
      case 'approve-all':
        await approvals.approveAll();
        break;
      case 'deny-all':
        approvals.denyAll();
        break;
    }
  });
}
